<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
      <template v-if="currentStep !== steps.INFORMATION" v-slot:customActions>
        <ActionButton
          text="Regresar"
          i="fas fa-arrow-circle-left fa-fw"
          variant="outline-success"
          class="m-1"
          @click="back()"
        />
        <ActionButton
          class="m-1"
          text="Continuar"
          variant="success"
          i="fas fa-arrow-circle-right"
          @click="onContinue"
        />
      </template>
      <template v-if="currentStep === steps.INFORMATION">
        <ActionButton
          text="Regresar"
          i="fas fa-arrow-circle-left fa-fw"
          variant="outline-success"
          class="m-1"
          @click="back()"
        />
        <ActionButton
          v-if="showSaveButton"
          class="m-1"
          text="Guardar"
          variant="success"
          i="fas fa-save"
          @click="onSaveRequest"
        />
        <ActionButton
          v-if="
            !isRequestReadOnly && !isNotNewAndSubmitted && !hideSubmittedBtn
          "
          class="m-1"
          text="Someter"
          variant="success"
          i="fas fa-flag"
          @click="onSubmitRequest"
        />
        <ChangeStatusDropdown
          v-if="showChangeStatus"
          v-model="model"
          :statuses="targetStatuses"
          @update="updateCurrentStatus"
        />
        <ActionButton
          v-if="canShowResume"
          class="m-1"
          text="Resumen"
          variant="success"
          i="fas fa-search"
          @click="goToResumePage"
        />
      </template>
    </page-header>

    <template v-if="showReturnToSchoolReasonBox">
      <ReasonForReturn
        title="Manejo de Estatus"
        :academic-year-id="model.academicYear.id"
        :regionId="informationHeader.regionId"
        :reason="isReturnedToSchool ? model.returnedReason : reasonHandler"
        :current-status-target="currentTargetStatus"
        :readonly="isReturnedToSchool"
        :assistant-selected="assistantSelected"
        :recommends-existing="recommendsExisting"
        @continue="onContinueReturnTo"
        @cancel="onCancelReturnTo"
      />
    </template>
    <template v-if="showHandlerStatus">
      <ReasonForReturn
        title="Manejo de Estatus"
        :reason="reasonHandler"
        :current-status-target="currentTargetStatus"
        :readonly="false"
        @continue="changeStatusToProcess"
        @cancel="cancelHandlerStatus"
      />
    </template>

    <template v-if="showReturnToTeacherFacilitatorReasonBox">
      <ReasonForReturn
        title="Manejo de Estatus"
        :reason="model.returnedReason"
        :current-status-target="currentTargetStatus"
        :readonly="isReturnedToTeacherFacilitator"
        @continue="onContinueReturnTo"
        @cancel="onCancelReturnTo"
      />
    </template>

    <template v-if="showReturnToCSEEDirectorReasonBox">
      <ReasonForReturn
        title="Razón de Devolución al CSEE"
        :reason="model.returnedReason"
        :current-status-target="currentTargetStatus"
        :readonly="isReturnedToCSEEDirector"
        @continue="onContinueReturnTo"
        @cancel="onCancelReturnTo"
      />
    </template>

    <template v-if="showRecommendedBox">
      <template v-if="showNewFeatures">
        <ReasonForReturn
          v-if="!isRecommended"
          title="Manejo de Estatus"
          :academic-year-id="model.academicYear.id"
          :regionId="informationHeader.regionId"
          :current-status-target="currentTargetStatus"
          :readonly="isRecommended"
          :persisted-data="persistedData"
          radio-title="¿Recomendado por?"
          radio-option-one="Nombramiento de Asistente"
          radio-option-two="Remedio Provisional"
          @continue="onContinueReturnTo"
          @cancel="onCancelReturnTo"
          @reset-rempro-btn="resetRecommendedBox"
        />
        <Saee10RecommendedInformation
          v-else
          :request-id="$route.params.id"
          :recommendation-types="collections.recommendationTypes"
        />
      </template>
      <template v-else>
        <RecommendedInformation
          :current-status-target="currentTargetStatus"
          :readonly="isRecommended"
          :collections="collections"
          @continue="onContinueReturnTo"
          @cancel="onCancelReturnTo"
        />
      </template>
    </template>

    <template v-if="showNotRecommendedBox">
      <ReasonForReturn
        title="Manejo de Estatus"
        :reason="model.notRecommendedReason"
        :current-status-target="currentTargetStatus"
        :readonly="isNotRecommended"
        is-not-recommended
        @continue="onContinueReturnTo"
        @cancel="onCancelReturnTo"
      />
    </template>

    <InformationHeader
      v-if="steps.INFORMATION === currentStep && model.id"
      ref="InformationHeader"
      :request-id="model.id"
      :assistant-type-id="model.assistantTypeId"
      :status-id="model.statusId"
      :information-header.sync="informationHeader"
    />

    <ValidationObserver ref="main-form">
      <div
        class="cursor--pointer"
        aria-expanded="true"
        aria-controls="collapseOne"
        @click="toggleExpand"
      >
        <div class="accordion-header-container">
          <div class="collapse-title d-flex">
            <span
              class="bg-light-gray my-3 p-2 mr-2 radius-20 font-weight-bold"
            >
              <span class="bg-white p-1 radius-100">
                <i
                  class="fal fa-lg"
                  :class="{
                    'fa-chevron-circle-right orange-icon': !getIsExpanded,
                    'fa-chevron-circle-down text-success': getIsExpanded,
                  }"
                />
              </span>
              Proceso realizado previo a Solicitud de Personal Irregular
            </span>
          </div>
        </div>
      </div>

      <div
        id="collapseOne"
        :key="'options'"
        :class="{
          'collapse mt-2': !getIsExpanded,
          'collapse show mt-2': getIsExpanded,
        }"
        aria-labelledby="headingOne"
      >
        <OrderedHeader order="1">
          <template v-slot:content>
            ¿Usted cuenta con el documento de la SAEE-10?
          </template>
          <template v-slot:actions>
            <CustomRadio
              is-question-list
              custom-error-msg=""
              class="ordered-header-card-custom-radio"
              :name="'rbQuestion-1'"
              :options="getYesNoOptions"
              :change-event="onChangeYesNo"
              :disabled="isReadOnly || !!currentStep"
            />
          </template>
          <template
            v-if="model.facilitatorDiscussionOccurred"
            v-slot:content-bottom
          >
            <div class="row p-3">
              <div class="col-md-5 col-sm-12 mb-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Año académico"
                  rules="required"
                >
                  <label class="input-label">Año académico:</label>
                  <CustomDropDown
                    v-model="model.academicYear"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="name"
                    :options="collections.academicYears"
                    :error="errors[0]"
                    :disabled="isReadOnly || !!currentStep"
                  />
                  <CustomError
                    v-if="errors[0]"
                    variant="no-border"
                    message="Favor seleccione año académico."
                  />
                </ValidationProvider>
              </div>
              <template>
                <div class="col-12 mt-2">
                  <label class="input-label">Justificación:</label>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="description"
                    :rules="'required'"
                  >
                    <CustomTextArea
                      :id="'description'"
                      v-model="model.facilitatorDiscussionDescription"
                      style="width: 100%"
                      :maxlength="3000"
                      :classes="['eq-field', 'text-right']"
                      :rows="5"
                      :error="errors[0]"
                      :custom-error-msg="'Favor escriba una descripción.'"
                      :disabled="isReadOnly || !!currentStep"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-12 col-md-6 mt-2">
                  <label class="input-label">Documento:</label>
                  <p class="document-name">
                    {{
                      model.facilitatorDiscussionEvidenceDocument
                        .documentTypeName
                    }}
                  </p>
                  <div
                    v-if="isGroupRequest"
                    class="col-12 d-flex align-items-start align-items-md-center mb-3"
                  >
                    <i class="far fa-exclamation-circle pr-1 form-icon" />
                    <p class="m-0">
                      Para la solicitud de grupo no es requerido el documento de
                      la SAEE-10A.
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md-6 mt-2 d-flex justify-content-start">
                  <template v-if="model.hasSaee10 && !isGroupRequest">
                    <div
                      v-for="student in model.studentList"
                      :key="student.studentSie"
                      class="d-flex align-items-center"
                    >
                      <div class="font-weight-normal">
                        <label class="circle-green"></label>
                        <label class="mb-0">
                          SAEE-10 - {{ student.studentSie }}
                        </label>
                      </div>
                      <div class="d-flex flex-row-reverse ml-2">
                        <ActionButton
                          class=" mr-2 ml-2"
                          variant="outline-success"
                          i="fas fa-file-download"
                          @click="buildSAEE10Report(student.lastSignedPei)"
                        />
                      </div>
                    </div>
                  </template>
                  <ValidationProvider
                    v-else
                    v-slot="{ errors }"
                    name="Archivo"
                    :rules="isGroupRequest ? '' : 'required'"
                  >
                    <CustomFileInput
                      v-model="model.facilitatorDiscussionEvidenceDocument.file"
                      :attachment-id="
                        model.facilitatorDiscussionEvidenceDocument
                          .itemAttachmentId
                      "
                      :name="
                        model.facilitatorDiscussionEvidenceDocument.filename
                      "
                      label="Archivo:"
                      :accept="'.pdf'"
                      display-style="normal"
                      label-position="left"
                      :max-size="10"
                      :error="errors[0]"
                      :custom-error-msg="
                        errors[0] ? 'Favor anejar un documento.' : ''
                      "
                      :disabled="isReadOnly"
                      :on-download="downloadFile"
                    />
                  </ValidationProvider>
                </div>
              </template>
            </div>
          </template>
        </OrderedHeader>
        <div
          v-if="!model.facilitatorDiscussionOccurred && showNoError"
          class="div-error"
        >
          <p class="px-2 mb-0">
            Favor de proceder a realizar el proceso de prediscusión de caso con
            el facilitador correspondiente. Una vez lo realice, podrá ingresar
            la evidencia y comenzar con el proceso de Solicitud de Personal
            Irregular.
          </p>
        </div>
      </div>

      <div
        v-if="model.facilitatorDiscussionOccurred"
        class="row mt-4 mt-lg-5"
        :class="{ collapse: !getIsExpanded, 'collapse show': getIsExpanded }"
      >
        <div class="col-lg-5 pr-lg-0">
          <div class="d-flex align-items-center bg-light-gray-f2 h-100">
            <span class="font-weight-bold m-3">
              La solicitud de personal irregular es para:
            </span>
          </div>
        </div>
        <div class="col-lg-7 pl-lg-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="Tipo solicitud"
            rules="required"
          >
            <CustomRadio
              is-question-list
              class="radio-icon"
              :value="model.assistantTypeId"
              :name="'tipoSolictud'"
              :error="!!errors[0]"
              :custom-error-msg="
                !!errors[0] ? 'Favor seleccionar el tipo de solicitud.' : ''
              "
              :options="getRequestTypeOptions(!!errors[0])"
              :change-event="onChangeRequestType"
              :disabled="isReadOnly || !!currentStep"
            />
          </ValidationProvider>
        </div>
      </div>

      <div
        v-if="model.facilitatorDiscussionOccurred"
        class="row mt-4 mt-lg-5 mb-lg-5"
        :class="{ collapse: !getIsExpanded, 'collapse show': getIsExpanded }"
      >
        <div class="col">
          <div class="d-flex align-items-center bg-light-gray-f2 h-100">
            <ul class="fa-ul pt-3 pb-3 text-muted">
              <li
                v-for="item in getRequestTypeOptions()"
                :key="item.id"
                class="p-2"
              >
                <span class="fa-li"><i :class="item.icon" /></span>
                <span class="font-weight-bold">{{ item.label }}</span>
                : {{ item.description }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <ValidationObserver ref="group-form">
      <SearchByGroup
        v-if="steps.GROUP_FORM === currentStep"
        v-model="model.custodian"
        :academic-year-id="model.academicYear.id"
      />
    </ValidationObserver>

    <StudentManagement
      v-if="steps.STUDENT_FORM === currentStep"
      v-model="model"
      :collections="collections"
      @click="onSearchStudent"
    />
    <custom-tab
      v-if="steps.INFORMATION === currentStep && model.id"
      ref="request-tabs"
      :no-nav-style="true"
      nav-class="nav-vue-underline"
      :model="tabIndex"
    >
      <custom-tab-item
        :lazy="false"
        :title="requestTypeTabTitle"
        :active="tabIndex === requestTabs.Solicitud"
        @click="setCurrentSaveFunction(requestTabs.Solicitud)"
      >
        <RequestInformation
          ref="informationForm"
          :canShowSignaturePanel="canShowSignaturePanel"
          v-model="model"
          :collections="collections"
          :is-read-only="isReadOnly"
          :is-phone-required="!isNewFeature"
          :are-justifications-required="!isNewFeature"
        />
      </custom-tab-item>

      <custom-tab-item
        v-if="!isRequestForOneStudent"
        :lazy="false"
        title="Listado de Estudiantes"
        :active="tabIndex === requestTabs.ListadoDeEstudiantes"
        @click="setCurrentSaveFunction(requestTabs.ListadoDeEstudiantes)"
      >
        <StudentManagement
          v-model="model"
          :is-read-only="isReadOnly"
          :collections="collections"
          :show-prov-rem-req-action="isSubmitted || showCreateRempProBtn"
          show-in-list-mode
          @onCreateProvRemReq="createProvisionalRemedyRequest"
          @onRemoveNecessity="
            (necessity) =>
              $refs.informationForm.setCheckNecessity(necessity, false)
          "
          @onRemoveStudent="
            (student) => $refs.informationForm.cleanDropDownsSelection(student)
          "
          @click="onSearchStudent"
        />
      </custom-tab-item>

      <custom-tab-item
        v-if="showTeacherFacilitatorAnalysis"
        :lazy="false"
        title="Análisis del Faciltador Docente"
        :active="tabIndex === requestTabs.AnalisisFacilitadorDocente"
        @click="setCurrentSaveFunction(requestTabs.AnalisisFacilitadorDocente)"
      >
        <ValidationObserver ref="teacherFacilitatorAnalysisTab">
          <TeacherFacilitatorAnalysis
            ref="teacherFacilitatorAnalysis"
            :canShowSignaturePanel="canShowSignaturePanel"
            :value="model"
            :collections="collections"
            :read-only="teacherFacilitatorAnalysisReadonly"
          />
        </ValidationObserver>
      </custom-tab-item>

      <custom-tab-item
        v-if="showCSEEAnalysis"
        :lazy="false"
        title="Análisis del CSEE"
        :active="tabIndex === requestTabs.AnalisisCSEE"
        save-function="$refs.serviceCenterAnalysis.save"
        @click="setCurrentSaveFunction(requestTabs.AnalisisCSEE)"
      >
        <ServiceCenterAnalysis
          ref="serviceCenterAnalysis"
          :canShowSignaturePanel="canShowSignaturePanel"
          :value="model"
          :collections="collections"
          :read-only="CSEEAnalysisReadonly"
        />
      </custom-tab-item>

      <custom-tab-item
        v-if="showSAEEAnalysis"
        :lazy="false"
        title="Análisis de la SAEE"
        :active="tabIndex === requestTabs.AnalisisSAEE"
        save-function="$refs.associateSecretarySpecialEducationAnalysis.save"
        @click="setCurrentSaveFunction(requestTabs.AnalisisSAEE)"
      >
        <AssociateSecretarySpecialEducationAnalysis
          ref="associateSecretarySpecialEducationAnalysis"
          :canShowSignaturePanel="canShowSignaturePanel"
          :value="model"
          :collections="collections"
          :read-only="SAEEAnalysisReadonly"
        />
      </custom-tab-item>
    </custom-tab>
  </div>
</template>

<script>
import _ from 'lodash';
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import CustomRadio from 'custom-radio';
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import CustomFileInput from 'CustomFileInput';
import CustomError from 'custom-error';
import OrderedHeader from 'ordered-header-card';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import alert from '@/mixin/alert.mixin';
import storeMixin from '@/mixin/storeGenerator';
import academicService from '@/services/api/academicUtils.api';
import resourcesService from '@/services/resources';
import documentsService from '@/services/documents';
import utilitiesService from '@/services/hr/utilities';
import documentNecessityConfigs from '@/utils/constants/hrrequest/documentNecessityConfigs';
import requestDocumentTypeCodes from '@/utils/constants/hrrequest/requestDocumentTypeCodes';
import locationService from '@/services/api/location.api';
import generalService from '@/services/pei/general';
import requestTypeOptions from '@/utils/constants/hrrequest/requestTypeOptions';
import {
  requestStatusCodes,
  requestStatusString,
} from '@/utils/constants/hrrequest/requestStatusCodes';
import { requestTypeCodes } from '@/utils/constants/hrrequest/requestTypeCodes';
import necessityCodes from '@/utils/constants/hrrequest/necessityCodes';
import yesNoOptions from '@/utils/constants/hrrequest/yesNoOptions';
import EduEspCode from '@/utils/constants/eduEspCode';
import formDataUtil from '@/utils/formDataUtil';
import SearchByGroup from './components/SearchByGroup';
import InformationHeader from './components/InformationHeader';
import RequestInformation from './components/tabs/tab1RequestInformation';
import StudentManagement from './components/tabs/tab2StudentManagement';
import TeacherFacilitatorAnalysis from './components/tabs/tab3TeacherFacilitatorAnalysis';
import ServiceCenterAnalysis from './components/tabs/tab4ServiceCenterAnalysis';
import AssociateSecretarySpecialEducationAnalysis from './components/tabs/tab5AssociateSecretarySpecialEducationAnalysis';
import {
  createRequest,
  saveRequest,
  submitRequest,
  deleteRequest,
  getStudentBySIE,
  getNecessitiesList,
  getStudentsByCustodian,
  getAlternativeStudentsByCustodian,
  getRequestData,
  updateRequestStatus,
  getTargetRequestStatuses,
  getStudentParams,
  getRecommendationTypes,
} from '@/modules/human-resources/api';
import ChangeStatusDropdown from './components/ChangeStatusDropdown';
import ReasonForReturn from './components/ReasonForReturn';
import RecommendedInformation from './components/RecommendedInformation';
import Saee10RecommendedInformation from './components/Saee10RecommendedInformation';
import store from '@/store/index';
import { getSchoolServiceAssistants } from '@/modules/human-resources/api';
import academicYears from '@/utils/constants/academicYears';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import rpStatuses from '@/utils/constants/rp/rpStatuses';

const steps = {
  STUDENT_FORM: 'STUDENT_FORM',
  GROUP_FORM: 'GROUP_FORM',
  INFORMATION: 'INFORMATION',
};

const modelInitialState = () => ({
  id: 0,
  statusId: 0,
  hasSaee10: false,
  assistantTypeId: null,
  academicYear: null,
  facilitatorDiscussionOccurred: false,
  facilitatorDiscussionDescription: null,
  facilitatorDiscussionEvidenceDocument: {
    file: null,
    filename: null,
    attachmentId: null,
    documentTypeName: null,
  },
  custodian: null,
  student: null,
  studentSIE: null,
  returnedReason: null,
  schoolHasAssistantsAvailable: null,
  studentList: [],
  schoolAssistants: [],
  necessities: [],
  signers: [],
  documents: [],
  districtHasAssistantsAvailable: null,
  teacherReason: null,
  districtAssistants: [],
  teacherDocuments: [],
  signersTeacher: [],
  centerHasAssistantsAvailable: null,
  centerReason: null,
  centerAssistants: [],
  centerAssistantLocation: {
    region: null,
    municipality: null,
    school: null,
    comment: null,
  },
  centerDocuments: [],
  signersCenter: [],
  signersSaee: [],
  notRecommendedReason: null,
});

const mapSigners = (signers) =>
  signers.map((signer) => ({
    id: signer.isSubmitted ? signer.id : 0,
    name: signer.fullName,
    role: {
      id: signer.rolId,
      name: signer.rolName,
    },
    position: {
      id: signer.positionId,
      name: signer.positionName,
    },
    phone: signer.telephoneNumber,
    email: signer.email,
    signed: signer.signed,
    isSubmitted: signer.isSubmitted,
  }));

const mapAssistants = (assistants, collections) =>
  assistants.map((assistant) => ({
    id: assistant.id,
    assistantName: collections.assistants.find(
      (e) => e.name == assistant.assistantName
    ),
    resourceType: collections.resourceTypes.find(
      (e) => e.id == assistant.resourceTypeId
    ),
    dailyShift: collections.dailyShifts.find(
      (e) => e.id == assistant.dailyShiftId
    ),
  }));

const mapDocuments = (documents) =>
  documents?.map((doc) => ({
    ...doc,
    itemAttachmentId: doc.documentId,
  }));

export default {
  name: 'HumanResourcesRequestPersonalStaff',
  mixins: [alert, storeMixin],
  components: {
    ValidationObserver,
    ValidationProvider,
    PageHeader,
    ActionButton,
    OrderedHeader,
    CustomError,
    CustomRadio,
    CustomDropDown,
    CustomTextArea,
    CustomFileInput,
    CustomTab,
    CustomTabItem,
    InformationHeader,
    RequestInformation,
    StudentManagement,
    TeacherFacilitatorAnalysis,
    ServiceCenterAnalysis,
    AssociateSecretarySpecialEducationAnalysis,
    SearchByGroup,
    ChangeStatusDropdown,
    ReasonForReturn,
    RecommendedInformation,
    Saee10RecommendedInformation,
  },
  props: {
    tab: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    moduleName: 'addEditRequestPersonalStaff',
    page: {
      icon: 'fas fa-user-edit',
      title: 'Solicitud de Personal Irregular',
      routes: ['Inicio', 'Recursos Humanos', 'Personal Irregular'],
    },
    steps,
    currentStep: null,
    isExpanded: true,
    reasonHandler: null,
    showNoError: false,
    showCreateRempProBtn: null,
    informationHeader: {},
    requestReturnInfo: null,
    model: modelInitialState(),
    sysParameters: [],
    collections: {
      resources: [],
      documentTypes: [],
      academicYears: [],
      necessities: [],
      resourceTypes: [],
      dailyShifts: [],
      regions: [],
      municipalities: [],
      assistants: [],
      schools: [],
      hygieneStudent: { id: necessityCodes.hygiene, list: [] },
      feedingStudent: { id: necessityCodes.feeding, list: [] },
      mobilityStudent: { id: necessityCodes.movility, list: [] },
      communicationStudent: { id: necessityCodes.comunication, list: [] },
      healthStudent: { id: necessityCodes.health, list: [] },
      transportationStudent: { id: necessityCodes.transportation, list: [] },
      othersStudent: { id: necessityCodes.others, list: [] },
      recommendationTypes: [],
    },
    requestId: null,
    targetStatuses: [],
    saveFunction: null,
    showReturnToSchool: false,
    showHandlerStatus: false,
    currentTargetStatus: null,
    showReturnToTeacherFacilitator: false,
    showReturnToCSEEDirector: false,
    showRecommended: false,
    showNotRecommended: false,
    studentParams: {},
    tabIndex: 0,
  }),
  watch: {
    async informationHeader() {
      if (!this.informationHeader || this.model.centerAssistantLocation.region)
        return;

      this.model.centerAssistantLocation.region = {
        id: this.informationHeader.regionId,
        name: this.informationHeader.regionName,
      };
      this.collections.regions = [this.model.centerAssistantLocation.region];

      const municipalityResult = await locationService.getMunicipalities({
        regionId: this.informationHeader.regionId,
        academicYearId: this.model.academicYear.id,
        IgnoreUserProfile: true,
      });
      this.collections.municipalities = municipalityResult.data;

      if (this.model.centerAssistantLocation.municipality) {
        this.model.centerAssistantLocation.municipality = this.collections.municipalities.find(
          (e) => e.id == this.model.centerAssistantLocation.municipality
        );
        const schoolResult = await locationService.getSchools({
          municipalityId: this.model.centerAssistantLocation.municipality?.id,
          academicYearId: this.model.academicYear.id,
          IgnoreUserProfile: true,
        });
        this.collections.schools = schoolResult.data;
      }
      if (this.model.centerAssistantLocation.school)
        this.model.centerAssistantLocation.school = this.collections.schools.find(
          (e) => e.id == this.model.centerAssistantLocation.school
        );

      this.getAssistants(null, this.informationHeader.locationSchoolId);
    },
  },
  computed: {
    persistedData() {
      let persistedData =
        this.$store?.state?.addEditRequestPersonalStaff?.data ?? {};

      if (persistedData && persistedData.id !== this.model.id) {
        persistedData = {};
        this.clearData();
      }

      return persistedData;
    },
    assistantSelected() {
      return this.requestReturnInfo && this.requestReturnInfo?.assistant
        ? this.requestReturnInfo.assistant
        : null;
    },
    recommendsExisting() {
      return (
        this.requestReturnInfo &&
        this.requestReturnInfo?.recommendsExisting === true
      );
    },
    isNewFeature() {
      return this.model.academicYear.id > academicYears.Y2022_2023;
    },
    isGroupRequest() {
      return this.model.assistantTypeId == requestTypeCodes.Grupo;
    },
    canShowSignaturePanel() {
      return (
        this.sysParameters.length > 0 &&
        this.sysParameters
          .find((p) => p.name === 'RHSignaturePanelHidden')
          ?.staticValue.toLowerCase() === 'false'
      );
    },
    requestTypeTabTitle() {
      let result = 'Solicitud';
      const requestType = requestTypeOptions.find(
        (rt) => rt.id == this.model.assistantTypeId
      );
      if (requestType) result += ` de ${requestType.label}`;
      return result;
    },
    getYesNoOptions() {
      return yesNoOptions.map((op) => ({
        ...op,
        check: this.model.facilitatorDiscussionOccurred == op.id,
        disabled: this.isReadOnly,
      }));
    },
    getRequestTypeOptions() {
      return (isValid) =>
        requestTypeOptions.map((op) => ({
          ...op,
          check: this.model.assistantTypeId == op.id,
          invalid: isValid,
          disabled: this.isReadOnly,
        }));
    },
    getIsExpanded() {
      return this.isExpanded;
    },
    isReadOnly() {
      return (
        !!this.model.statusId &&
        !(
          this.model.statusId === requestStatusCodes.new ||
          this.model.statusId === requestStatusCodes.returnedToSchool
        )
      );
    },
    isRequestReadOnly() {
      return (
        this.model.statusId === requestStatusCodes.submitted ||
        this.isPendingCSEEAnalysis ||
        this.isSAEEPendingAnalysis ||
        this.isRecommended ||
        this.isNotRecommended ||
        this.isRecommendedExistingResource
      );
    },
    isNotNewAndSubmitted() {
      return (
        this.model.statusId !== requestStatusCodes.submitted &&
        this.model.statusId !== requestStatusCodes.new &&
        this.model.statusId !== requestStatusCodes.returnedToSchool
      );
    },
    isRequestForOneStudent() {
      return this.model.assistantTypeId == requestTypeCodes.Estudiantes;
    },
    hideSubmittedBtn() {
      return (
        this.showChangeStatus &&
        this.targetStatuses.findIndex(
          (x) => x.id === requestStatusCodes.submitted
        ) !== -1
      );
    },
    showChangeStatus() {
      if (
        this.isCSEEAnalysisProcess ||
        this.isSAEEAnalysisProcess ||
        this.isSubmitted ||
        this.isReturnedToCSEEDirector ||
        (this.isReturnedToSchool && this.targetStatuses.length > 1)
      )
        return true;

      if (
        this.tabIndex === this.requestTabs.AnalisisFacilitadorDocente &&
        (this.isTeacherFacilitatorAnalysis ||
          this.isReturnedToTeacherFacilitator ||
          this.isPendingCSEEAnalysis)
      )
        return true;

      if (
        this.tabIndex === this.requestTabs.AnalisisCSEE &&
        (this.isCSEEAnalysisProcess ||
          this.isReturnedToCSEEDirector ||
          this.isSAEEPendingAnalysis)
      )
        return true;

      if (
        this.tabIndex === this.requestTabs.AnalisisSAEE &&
        this.isSAEEAnalysisProcess
      )
        return true;

      return false;
    },
    showTeacherFacilitatorAnalysis() {
      return (
        this.isNotNewAndSubmitted &&
        (!this.isRecommendedExistingResource ||
          this.model.districtHasAssistantsAvailable != null) &&
        !(
          (this.isTeacherFacilitatorAnalysis ||
            this.isReturnedToTeacherFacilitator) &&
          !store.getters.HasPermission(
            'humanresources.irregularstaff.canseewhileprocesingfacilitator'
          )
        )
      );
    },
    isTeacherFacilitatorAnalysis() {
      return (
        this.model.statusId ===
        requestStatusCodes.teacherFacilitatorAnalysisProcess
      );
    },
    showReturnToSchoolReasonBox() {
      if (!this.isNewIrregularRequestModule) {
        return (
          this.showReturnToSchool ||
          this.model.statusId === requestStatusCodes.returnedToSchool
        );
      }
      return this.showReturnToSchool;
    },
    isReturnedToSchool() {
      return this.model.statusId === requestStatusCodes.returnedToSchool;
    },
    showCSEEAnalysis() {
      return (
        (this.isCSEEAnalysisProcess ||
          this.isSAEEAnalysisProcess ||
          this.isSAEEPendingAnalysis ||
          this.isReturnedToTeacherFacilitator ||
          this.isReturnedToCSEEDirector ||
          this.isRecommended ||
          this.isNotRecommended ||
          (this.isRecommendedExistingResource &&
            this.model.centerHasAssistantsAvailable != null)) &&
        !(
          (this.isCSEEAnalysisProcess || this.isReturnedToCSEEDirector) &&
          !store.getters.HasPermission(
            'humanresources.irregularstaff.canseewhileprocesingcsee'
          )
        )
      );
    },
    isCSEEAnalysisProcess() {
      return this.model.statusId === requestStatusCodes.CSEEAnalysisProcess;
    },
    showSAEEAnalysis() {
      return (
        (this.isSAEEAnalysisProcess ||
          this.isRecommended ||
          this.isNotRecommended) &&
        !(
          this.isSAEEAnalysisProcess &&
          !store.getters.HasPermission(
            'humanresources.irregularstaff.canseewhileprocesingsaee'
          )
        )
      );
    },
    isSAEEAnalysisProcess() {
      return this.model.statusId === requestStatusCodes.SAEEAnalysisProcess;
    },
    showReturnToTeacherFacilitatorReasonBox() {
      return (
        this.showReturnToTeacherFacilitator ||
        this.isReturnedToTeacherFacilitator
      );
    },
    isReturnedToTeacherFacilitator() {
      return (
        this.model.statusId === requestStatusCodes.returnedToFacilitatorTeacher
      );
    },
    showReturnToCSEEDirectorReasonBox() {
      return this.showReturnToCSEEDirector || this.isReturnedToCSEEDirector;
    },
    isReturnedToCSEEDirector() {
      return this.model.statusId === requestStatusCodes.returnedToCSEEDirector;
    },
    isPendingCSEEAnalysis() {
      return this.model.statusId === requestStatusCodes.pendingCSEEAnalysis;
    },
    teacherFacilitatorAnalysisReadonly() {
      return !(
        this.isTeacherFacilitatorAnalysis || this.isReturnedToTeacherFacilitator
      );
    },
    CSEEAnalysisReadonly() {
      return !(this.isReturnedToCSEEDirector || this.isCSEEAnalysisProcess);
    },
    isSAEEPendingAnalysis() {
      return this.model.statusId === requestStatusCodes.SAEEPendingAnalysis;
    },
    isRecommended() {
      return this.model.statusId === requestStatusCodes.recomended;
    },
    SAEEAnalysisReadonly() {
      return !this.isSAEEAnalysisProcess;
    },
    showRecommendedBox() {
      return this.showRecommended || this.isRecommended;
    },
    isNotRecommended() {
      return this.model.statusId === requestStatusCodes.notRecomended;
    },
    showNotRecommendedBox() {
      return this.showNotRecommended || this.isNotRecommended;
    },
    requestTabs() {
      return {
        Solicitud: 0,
        ListadoDeEstudiantes: 1,
        AnalisisFacilitadorDocente: 2,
        AnalisisCSEE: 3,
        AnalisisSAEE: 4,
      };
    },
    isRecommendedExistingResource() {
      return (
        this.model.statusId === requestStatusCodes.RecommendedExistingResource
      );
    },
    showSaveButton() {
      if (
        (this.tabIndex === this.requestTabs.Solicitud ||
          this.tabIndex === this.requestTabs.ListadoDeEstudiantes) &&
        (this.isReturnedToSchool || this.isNew)
      )
        return true;

      if (
        this.tabIndex === this.requestTabs.AnalisisFacilitadorDocente &&
        (this.isTeacherFacilitatorAnalysis ||
          this.isReturnedToTeacherFacilitator)
      )
        return true;

      if (
        this.tabIndex === this.requestTabs.AnalisisCSEE &&
        (this.isCSEEAnalysisProcess || this.isReturnedToCSEEDirector)
      )
        return true;

      if (
        this.tabIndex === this.requestTabs.AnalisisSAEE &&
        this.isSAEEAnalysisProcess
      )
        return true;

      return false;
    },
    isCSEEAnalysisProcess() {
      return this.model.statusId === requestStatusCodes.CSEEAnalysisProcess;
    },
    isNew() {
      return this.model.statusId === requestStatusCodes.new;
    },
    isSubmitted() {
      return this.model.statusId === requestStatusCodes.submitted;
    },
    isNewIrregularRequestModule() {
      return (
        this.$route.name == 'EditIrregularRequestPersonalStaff' ||
        this.$route.query?.newModule == 1
      );
    },
    canShowResume() {
      return (
        this.isNewIrregularRequestModule &&
        [
          requestStatusCodes.submitted,
          requestStatusCodes.teacherFacilitatorAnalysisProcess,
          requestStatusCodes.CSEEAnalysisProcess,
          requestStatusCodes.SAEEAnalysisProcess,
        ].includes(this.model.statusId) &&
        this.showNewFeatures
      );
    },
    showNewFeatures() {
      return this.model.academicYear.id >= academicYears.Y2023_2024;
    },
  },
  methods: {
    loadPersistedData() {
      if (Object.keys(this.persistedData).length === 0) return;

      this.currentTargetStatus = this.persistedData.currentTargetStatus;
      this.showCreateRempProBtn = this.persistedData.showCreateRempProBtn;
      this.showRecommended = this.persistedData.showRecommended;
    },
    resetRecommendedBox(cancelAction = false) {
      if (this.persistedData?.reason) {
        this.clearData();
      }
      if (cancelAction) {
        this.showCreateRempProBtn = false;
        this.showRecommended = false;
      }
    },
    runCreateRemProRequest() {
      const studentSie = this.isRequestForOneStudent
        ? _.get(this.model, 'studentList.0.studentSie')
        : null;
      this.createProvisionalRemedyRequest(studentSie);
    },
    getCreateRequestFormData() {
      const formData = new FormData();

      formData.append('id', this.model.id);
      formData.append(
        'facilitatorDiscussionOccurred',
        this.model.facilitatorDiscussionOccurred
      );
      formData.append('assistantTypeId', this.model.assistantTypeId);
      formData.append('academicYearId', this.model.academicYear?.id);
      formData.append(
        'facilitatorDiscussionDescription',
        this.model.facilitatorDiscussionDescription
      );
      formData.append(
        'facilitatorDiscussionEvidenceFile',
        this.model.facilitatorDiscussionEvidenceDocument.file
      );
      return formData;
    },
    getSaveRequestFormData(submitted) {
      const formData = new FormData();
      formDataUtil.build(formData, this.model.id, 'requestId');
      formDataUtil.build(formData, this.model.contactPhone, 'contactNumber');
      formDataUtil.build(formData, this.model.necessities, 'necessities');
      formDataUtil.build(formData, this.model.documents, 'documents');
      formDataUtil.build(
        formData,
        this.model.schoolHasAssistantsAvailable,
        'schoolHasAssistantsAvailable'
      );
      if (
        this.model.schoolHasAssistantsAvailable &&
        this.model.schoolAssistants.length
      ) {
        formDataUtil.build(
          formData,
          this.model.schoolAssistants.map((assistant) => ({
            id: assistant.id,
            assistantName: assistant.assistantName.name,
            dailyShiftId: assistant.dailyShift.id,
            resourceTypeId: assistant.resourceType.id,
          })),
          'schoolAssistants'
        );
      }
      if (this.model.studentList.length) {
        let studentList = this.model.studentList.map((e) => {
          return { studentSie: e.studentSie, statusId: e.statusId };
        });
        formDataUtil.build(formData, studentList, 'students');
      }
      if (this.model.signers.length)
        formDataUtil.build(
          formData,
          this.model.signers.map((signer) => ({
            id: signer.id || 0,
            requestId: this.model.id,
            fullName: signer.name,
            positionId: signer.position.id,
            telephoneNumber: signer.phone,
            email: signer.email,
            signed: signer.signed,
            isSubmitted: signer.isSubmitted || !!submitted,
          })),
          'principalSignatures'
        );

      if (this.model.facilitatorDiscussionEvidenceDocument.file) {
        formData.append(
          'facilitatorDiscussionEvidenceFile',
          this.model.facilitatorDiscussionEvidenceDocument.file
        );
      }

      return formData;
    },
    getDocumentType(documentTypeId) {
      return (
        this.collections.documentTypes.find(
          (docType) => docType.id === documentTypeId
        ) || {}
      );
    },
    async setModelInitialState({ data }) {
      this.mapRequestData(data);
      this.model.id = data.requestId;
      this.model.hasSaee10 = data.hasSaee10;
      this.model.statusId = data.statusId;
      this.model.facilitatorDiscussionOccurred =
        data.facilitatorDiscussionOcurred;
      this.model.facilitatorDiscussionDescription =
        data.facilitatorDiscussionDescription;
      this.model.assistantTypeId = data.assistantTypeId.toString();
      this.model.returnedReason = data.returnedReason;
      this.model.notRecommendedReason = data.notRecommendedReason;
      this.model.contactPhone = data.contactNumber;
      this.model.necessities = data.necessities;
      this.model.studentList = data.students;
      this.model.assistant = data.assistantId;
      this.model.schoolHasAssistantsAvailable =
        data.schoolHasAssistantsAvailable;
      this.model.teacherReason = data.teacherReason;
      this.model.districtHasAssistantsAvailable =
        data.districtHasAssistantsAvailable;
      this.model.centerReason = data.centerReason;
      this.model.centerHasAssistantsAvailable =
        data.centerHasAssistantsAvailable;
      this.model.academicYear = this.collections.academicYears.find(
        (academicYear) => academicYear.id == data.academicYearId
      );
      this.model.facilitatorDiscussionEvidenceDocument =
        mapDocuments(data.documents).find(
          (doc) =>
            doc.documentTypeId ==
            requestDocumentTypeCodes.EvidenciaPreConsultaPersonalIrregularAlFacilitador
        ) || {};
      this.model.documents = mapDocuments(
        data.documents.filter(
          (doc) =>
            doc.documentTypeId !=
            requestDocumentTypeCodes.EvidenciaPreConsultaPersonalIrregularAlFacilitador
        )
      );
      this.model.teacherDocuments = mapDocuments(data.teacherDocuments);
      this.model.centerDocuments = mapDocuments(data.centerDocuments);
      this.model.signers = mapSigners(data.principalSignatures);
      this.model.signersTeacher = mapSigners(data.teacherSignatures);
      this.model.signersCenter = mapSigners(data.centerSignatures);
      this.model.signersSaee = mapSigners(data.saeeSignatures);
      await this.getAssistants(data);

      this.model.schoolAssistants = mapAssistants(
        data.schoolAssistants,
        this.collections
      );
      this.model.districtAssistants = mapAssistants(
        data.districtAssistants,
        this.collections
      );
      this.model.centerAssistants = mapAssistants(
        data.centerAssistants,
        this.collections
      );

      if (data.centerHasAssistantsAvailable)
        this.model.centerAssistantLocation = {
          municipality: data.assistanceLocationMunicipalityId,
          school: data.assistanceLocationSchoolId,
          comment: data.assistanceLocationComment,
        };

      if (!this.model.studentList.length)
        this.currentStep =
          this.model.assistantTypeId == requestTypeCodes.Grupo
            ? this.steps.GROUP_FORM
            : this.steps.STUDENT_FORM;
      else this.currentStep = this.steps.INFORMATION;

      // JSF: if request is in statusIds then show the read-only box with text reason
      const statusIds = [
        requestStatusCodes.returnedToSchool,
        requestStatusCodes.notRecomended,
      ];
      if (
        data.requestReturnInfo?.reason &&
        statusIds.some((id) => id === data.requestReturnInfo?.statusId)
      ) {
        this.currentTargetStatus = { id: data.requestReturnInfo?.statusId };
        this.showReturnToSchool =
          data.requestReturnInfo?.statusId ===
          requestStatusCodes.returnedToSchool;
        this.showNotRecommended =
          data.requestReturnInfo?.statusId === requestStatusCodes.notRecomended;
        this.requestReturnInfo = data.requestReturnInfo;
      } else {
        this.requestReturnInfo = null;
      }
    },
    mapRequestData(data) {
      data.necessities.forEach((necessity) => {
        necessity.name = this.collections.necessities.find(
          (n) => n.id == necessity.necessityId
        ).name;

        const documentConfig = documentNecessityConfigs.find(
          (config) => config.necessityId == necessity.necessityId
        );

        necessity.studentNecessities.forEach((studentNecessity) => {
          studentNecessity.student = data.students.find(
            (s) => s.studentSie == studentNecessity.studentSieId
          );
          studentNecessity.name = studentNecessity.student.name;
          studentNecessity.assistantTypes = studentNecessity.assistantTypesId.map(
            (assistantTypeId) => {
              return studentNecessity.student.serviceNeeds
                .filter((sn) => sn.id == assistantTypeId)
                .map((sn) => ({
                  id: sn.id,
                  name: sn.spaShortDescription,
                }))
                .find((x) => x);
            }
          );
          this.mapRequestDocument(studentNecessity, documentConfig);
        });
      });
    },
    mapRequestDocument(studentNecessity, documentConfig) {
      if (documentConfig) {
        const documentTypeIds = documentConfig.documentTypes.map(
          (docType) => docType.id
        );
        documentConfig.documentTypes.forEach((docType) => {
          const missingDocument = !studentNecessity.documents.some(
            (doc) => doc.documentTypeId === docType.id
          );
          if (missingDocument) {
            const document = utilitiesService.createDocument
              .bind(this, docType.id, docType.rules)
              .call();
            if (Math.min(...documentTypeIds) === docType.id)
              studentNecessity.documents.unshift(document);
            else studentNecessity.documents.push(document);
          }
        });
      }
    },
    setPrincipalDocumentTypeName() {
      const documentType = this.collections.documentTypes.find(
        (docType) =>
          docType.id ===
          requestDocumentTypeCodes.EvidenciaPreConsultaPersonalIrregularAlFacilitador
      );
      if (documentType)
        this.model.facilitatorDiscussionEvidenceDocument.documentTypeName =
          documentType.name;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    onChangeRequestType(item) {
      this.model.assistantTypeId = item.id.toString();
    },
    downloadFile(attachmentId) {
      documentsService.downloadFromServer(attachmentId);
    },
    async buildSAEE10Report(peiId) {
      try {
        const { data } = await this.$ApiGet(`/api/report/saee10/${peiId}`);
        await generalService.documentDownloadReport(
          data.content,
          data.filename
        );
      } catch (error) {
        this.ShowToast(
          '',
          'Ocurrio un problema al descargar el reporte, vuelve a intentarlo.',
          'error'
        );
      }
    },
    async onChangeYesNo(item) {
      if (item.id == this.model.facilitatorDiscussionOccurred) return;
      this.showNoError = false;
      if (!item.id && this.model.id) {
        const response = await this.ShowCancelModal(
          'Confirmación',
          `Usted cuenta con una solicitud creada en sistema, ¿Está que seguro que desea eliminar la solicitud?`,
          'Sí',
          'No'
        );
        if (!response) {
          this.model.facilitatorDiscussionOccurred = true;
          return;
        }
        const res = await deleteRequest(this.model.id);
        if (res.status == 200) {
          this.showNoError = true;
          this.currentStep = null;
          this.model = modelInitialState();
        } else return;
      }
      this.model.facilitatorDiscussionOccurred = item.id;
    },
    async createResquest(formData) {
      const response = await createRequest(formData).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message, 'error');
      });
      if (response.status == 200) {
        this.model.id = response.data.id;
        this.model.statusId = requestStatusCodes.new;
        this.model.requestPersonalTwoOrMoreMin =
          response.data.requestPersonalTwoOrMoreMin;
        this.model.requestPersonalTwoOrMoreMax =
          response.data.requestPersonalTwoOrMoreMax;
        this.model.requestPersonalGroupMin =
          response.data.requestPersonalGroupMin;
        this.model.requestPersonalGroupMax =
          response.data.requestPersonalGroupMax;
        return true;
      } else return false;
    },
    async onSaveRequest(submitted) {
      if (!this.saveFunction) {
        await this.saveRequest();
      } else {
        await this.saveFunction(submitted);
      }
    },
    async saveRequest() {
      const saveResult = await saveRequest(this.getSaveRequestFormData())
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'La solicitud ha sido guardado exitosamente.',
            'success'
          );
          return true;
        })
        .catch((err) => {
          this.ShowToast('Alerta', err.response.data.message, 'error');
        });
      if (saveResult) {
        await this.getRequestData(this.model.id).catch(() => {
          this.ShowToast('Alerta', 'Ocurrió un error inesperado', 'error');
        });
      }
    },
    async onSubmitRequest() {
      const _studentsWithoutNeeds = this.$refs.informationForm.getStudentsWithoutNeeds();
      const isFormValid = await this.$refs.informationForm.validateForm();

      if (!isFormValid) {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }

      if (!this.isGroupRequest && _studentsWithoutNeeds.length > 0) {
        const studentNames = _studentsWithoutNeeds
          .map((x) => x.name)
          .join(', ');
        this.ShowToast(
          'Alerta',
          `El(los) siguiente(s) estudiante(s) no cuenta(n) con una necesidad documentada en sistema. Favor de removerlo(s) de la solicitud o documentarle(s) la(s) necesidad(es) correspondiente: ${studentNames}`,
          'error',
          null,
          10000
        );
        return;
      }

      var submitResult = await submitRequest(this.getSaveRequestFormData(true))
        .then(() => {
          return true;
        })
        .catch((err) => {
          this.ShowToast('Alerta', err.response.data.message, 'error');
        });

      if (submitResult) {
        await this.getRequestData(this.model.id);
        this.showReturnToSchool = false;
        await this.getTargetStatuses();
        await this.$refs.InformationHeader.getInformation();
        this.ShowToast(
          'Confirmación',
          'La solicitud ha sido cambiada de estatus exitosamente.',
          'success'
        );
      }
    },
    back() {
      this.clearData();
      if (this.isNewIrregularRequestModule) {
        this.$router.push({
          path: '/humanres/irregularStaffRequest/#solicitudes',
        });
        return;
      }

      this.$router.push({ path: '/humanres/request' });
    },
    async onContinue() {
      this.showNoError = !this.model.facilitatorDiscussionOccurred;
      if (this.showNoError) return;

      const isValid = await this.$refs['main-form'].validate();
      if (!this.currentStep && !isValid) {
        this.ShowToast(
          'Alerta',
          'Favor de completar la información solicitada para continuar.',
          'error'
        );
        return isValid;
      }

      this.isExpanded = false;
      switch (parseInt(this.model.assistantTypeId)) {
        case requestTypeCodes.Estudiantes:
          await this.onContinueSearchStudent();
          break;
        case requestTypeCodes.DosMasEstudiantes:
          await this.onContinueSearchStudent();
          break;
        case requestTypeCodes.Grupo:
          await this.onContinueSearchGroup();
          break;
      }
    },
    async onContinueSearchGroup() {
      if (this.steps.GROUP_FORM === this.currentStep) {
        const isValid = await this.$refs['group-form'].validate();
        if (!isValid) return;

        var result = null;

        if (this.model.academicYear.id >= academicYears.Y2022_2023) {
          result = await getAlternativeStudentsByCustodian(
            this.model.custodian.id,
            this.model.academicYear.id
          );
        } else {
          result = await getStudentsByCustodian(
            this.model.custodian.id,
            this.model.academicYear.id
          );
        }

        if (result && result.data) {
          this.model.studentList = result.data;
        }

        const formData = this.getCreateRequestFormData();
        formDataUtil.build(formData, this.model.custodian.id, 'custodianId');
        let studentList = this.model.studentList;
        formDataUtil.build(formData, studentList, 'students');

        if (
          this.model.studentList.length <
          this.studentParams.requestPersonalGroupMin
        ) {
          this.ShowToast(
            'Alerta',
            'No es posible crear una solicitud de grupo ya que el maestro no cuenta con la cantidad requerida. Favor de regresar al paso anterior.',
            'error'
          );
          return;
        }
        const isSuccess = await this.createResquest(formData);
        if (isSuccess) this.currentStep = this.steps.INFORMATION;
      } else if (!this.currentStep) this.currentStep = this.steps.GROUP_FORM;
    },
    async onContinueSearchStudent() {
      if (this.steps.STUDENT_FORM === this.currentStep) {
        if (
          this.model.assistantTypeId == requestTypeCodes.Estudiantes &&
          !this.model.studentList.length
        ) {
          this.ShowToast('Alerta', 'Favor seleccionar un estudiante.', 'error');
        } else if (
          this.model.assistantTypeId == requestTypeCodes.DosMasEstudiantes &&
          this.model.studentList.length < 2
        ) {
          this.ShowToast(
            'Alerta',
            'Favor seleccionar al menos dos estudiante.',
            'error'
          );
        } else if (this.model.studentList.length) {
          const formData = this.getCreateRequestFormData();
          if (this.model.studentList.length) {
            let studentList = this.model.studentList;
            formDataUtil.build(formData, studentList, 'students');
          }
          const isSuccess = await this.createResquest(formData);
          if (isSuccess) this.currentStep = this.steps.INFORMATION;
        }
      } else if (!this.currentStep) this.currentStep = this.steps.STUDENT_FORM;
    },
    async onSearchStudent() {
      try {
        const { data } = await getStudentBySIE(
          this.model.id,
          this.model.studentSIE,
          this.model.academicYear.id
        );
        if (
          data.hasRequest &&
          this.model.assistantTypeId == requestTypeCodes.Estudiantes
        ) {
          this.ShowToast(
            'Alerta',
            this.collections.resources['R9260053'],
            'error'
          );
          return;
        }
        this.model.student = data;
      } catch (ex) {
        this.model.student = null;
        this.ShowToast('Alerta', ex.response.data.message, 'error');
      }
    },
    async fetchDropDownsData() {
      const { data: current } = await academicService.getCurrentAcademicYear();

      const resultAcademicYears = await academicService.getHRrequestAcademicYears(
        current.year
      );
      this.collections.academicYears = resultAcademicYears.map(
        (academicYear) => ({
          ...academicYear,
          name: academicYear.description,
        })
      );
      const resultNecesities = await getNecessitiesList();
      this.collections.necessities = resultNecesities.data.map((necessity) => ({
        ...necessity,
        selected: false,
      }));
      const resultResourceType = await academicService.getEduEsp({
        codetype: EduEspCode.ResourceType,
      });
      this.collections.resourceTypes = resultResourceType.data;
      const resultDailyShift = await academicService.getEduEsp({
        codetype: EduEspCode.DailyShift,
      });
      this.collections.dailyShifts = resultDailyShift.data;

      const recommendationTypes = await getRecommendationTypes();
      this.collections.recommendationTypes = recommendationTypes;
    },
    async getAssistants(request = null, locationSchool = null) {
      var locationSchoolId = request
        ? request.students[0].locationSchoolId
        : locationSchool;
      var academicYearId = request
        ? request.academicYearId
        : this.model.academicYear.id;

      await getSchoolServiceAssistants({
        academicYearId: academicYearId,
        locationSchoolId: locationSchoolId,
      }).then((data) => {
        this.collections.assistants = data;
      });
    },
    async getTargetStatuses() {
      let valueTochangeconfigStatus;
      if (
        (this.model.academicYear.id == academicYears.Y2022_2023 &&
          this.model.statusId == requestStatusCodes.submitted) ||
        (this.model.academicYear.id < academicYears.Y2023_2024 &&
          this.model.statusId == requestStatusCodes.returnedToCSEEDirector)
      ) {
        valueTochangeconfigStatus = false;
      } else {
        valueTochangeconfigStatus = this.isNewIrregularRequestModule;
      }
      const data = await getTargetRequestStatuses(
        valueTochangeconfigStatus,
        this.model.statusId,
        this.model.academicYear.id
      );
      this.targetStatuses = data.filter(
        (e) =>
          !e.permissionNeeded || store.getters.HasPermission(e.permissionNeeded)
      );
    },
    async fetchResources() {
      const resultDocumentTypes = await documentsService.getDocumentTypes(
        'HRRequest'
      );
      this.collections.documentTypes = resultDocumentTypes.data;
      this.collections.resources = await resourcesService.LoadValidationMessages(
        ['R01210001', 'R01210002', 'R01210003', 'R01210004', 'R9260053']
      );
    },
    async getRequestData(requestId) {
      await getRequestData(requestId)
        .then(this.setModelInitialState)
        .catch();
    },
    cancelHandlerStatus() {
      this.showHandlerStatus = false;
    },
    async updateCurrentStatus(status) {
      this.currentTargetStatus = status;

      switch (status.id) {
        case requestStatusCodes.returnedToSchool:
          if (this.validateProvRemReqStarted()) {
            return;
          }
          this.model.returnedReason = null;
          this.openReturnToSchool();
          break;
        case requestStatusCodes.returnedToFacilitatorTeacher:
          this.model.returnedReason = null;
          this.openReturnToTeacherFacilitator();
          break;
        case requestStatusCodes.returnedToCSEEDirector:
          this.model.returnedReason = null;
          this.onCancelReturnTo();
          this.openReturnToCSEEDirector();
          break;
        case requestStatusCodes.recomended:
          this.onCancelReturnTo();
          this.openRecommended();
          return;
        case requestStatusCodes.notRecomended:
          this.onCancelReturnTo();
          this.openNotRecommended();
          return;
        case requestStatusCodes.SAEEAnalysisProcess:
          this.showHandlerStatus = true;
          return;
        case requestStatusCodes.CSEEAnalysisProcess:
          if (this.validateProvRemReqStarted()) {
            return;
          }
          this.showHandlerStatus = true;
          return;
        case requestStatusCodes.CreateProvisionalRemedyRequest:
          this.runCreateRemProRequest();
          return;
      }

      if (!status.needReason) {
        this.onCancelReturnTo();

        if (status.id === requestStatusCodes.pendingCSEEAnalysis) {
          await this.openTeacherFacilitatorTab();

          const validSignature = !this.canShowSignaturePanel
            ? true
            : await this.validateAnalysisTab('teacherFacilitatorAnalysis');

          const validInformation =
            (await this.$refs['teacherFacilitatorAnalysis'].$refs[
              'analysis-general-info'
            ]?.validate()) ?? true;

          if (!validSignature || !validInformation) {
            this.ShowToast(
              'Información Incompleta',
              'Favor de completar la información solicitada.',
              'error'
            );
            return;
          }
          this.showReturnToTeacherFacilitator = false;
        } else if (status.id == requestStatusCodes.SAEEPendingAnalysis) {
          await this.openCSEEAnalysisTab();

          let validSignature = await this.validateAnalysisTab(
            'serviceCenterAnalysis'
          );

          let validInformation =
            (await this.$refs['serviceCenterAnalysis'].$refs[
              'analysis-general-info'
            ]?.validate()) ?? true;

          let validLocationInformation =
            (await this.$refs['serviceCenterAnalysis'].$refs[
              'analysis-location-info'
            ]?.validate()) ?? true;

          if (
            !validSignature ||
            !validInformation ||
            !validLocationInformation
          ) {
            this.ShowToast(
              'Información Incompleta',
              'Favor de completar la información solicitada.',
              'error'
            );
            return;
          }
          this.showReturnToCSEEDirector = false;
        }

        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea poder cambiar el estatus de ${
            requestStatusString[this.model.statusId]
          } a ${status.description}?`
        );

        if (answer) {
          await this.onSaveRequest(true);
          await updateRequestStatus(
            this.isNewIrregularRequestModule,
            this.model.id,
            status
          )
            .then(() => {
              this.model.statusId = status.id;
              this.model.returnedReason = null;
              this.getRequestData(this.model.id);
              this.getTargetStatuses().then(() => {
                this.$refs.InformationHeader.getInformation();
              });
              this.ShowToast(
                'Confirmación',
                'La solicitud ha sido cambiada de estatus exitosamente.',
                'success'
              );
              this.setActiveTab(status.id);
            })
            .catch((error) => {
              this.ShowToast(
                'Información Incompleta',
                error.response.data.message,
                'error'
              );
            });
        }
      }
    },

    goToTab(tab) {
      if (_.isNil(tab)) return;
      this.tabIndex = tab;
      this.$refs['request-tabs'].$el.scrollIntoView({ behavior: 'smooth' });
    },
    // Open Tabs
    openTeacherFacilitatorTab() {
      if (this.isRequestForOneStudent) {
        this.$refs['request-tabs'].tabModel = 1;
      } else {
        this.$refs['request-tabs'].tabModel = 2;
      }
      this.setManualSaveFunc(this.$refs.teacherFacilitatorAnalysis.save);
    },

    openCSEEAnalysisTab() {
      if (this.isRequestForOneStudent) {
        this.$refs['request-tabs'].tabModel = 2;
      } else {
        this.$refs['request-tabs'].tabModel = 3;
      }
      this.setManualSaveFunc(this.$refs.serviceCenterAnalysis.save);
    },

    openSAEEAnalysisTab() {
      if (this.isRequestForOneStudent) {
        this.$refs['request-tabs'].tabModel = 3;
      } else {
        this.$refs['request-tabs'].tabModel = 4;
      }
      this.model.districtHasAssistantsAvailable = true;
      this.setManualSaveFunc(
        this.$refs.associateSecretarySpecialEducationAnalysis.save
      );
    },

    openReturnToSchool() {
      this.showReturnToSchool = true;
    },

    openReturnToTeacherFacilitator() {
      this.showReturnToTeacherFacilitator = true;
      this.openCSEEAnalysisTab();
    },

    openReturnToCSEEDirector() {
      this.showReturnToCSEEDirector = true;
      this.openSAEEAnalysisTab();
    },

    async openRecommended() {
      this.showNotRecommended = false;
      this.showRecommended = true;
    },

    async openNotRecommended() {
      this.showRecommended = false;
      this.showNotRecommended = true;
    },
    async changeStatusToProcess(model) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea poder cambiar el estatus de ${
          requestStatusString[this.model.statusId]
        } a ${requestStatusString[this.currentTargetStatus.id]}?`
      );
      if (answer) {
        const dto = {
          id: model.currentStatusTargetId,
          reason: model.reason,
          recommendationTypeId: model.recommendationType?.id ?? null,
        };
        await updateRequestStatus(true, this.model.id, dto)
          .then(async () => {
            this.model.statusId = dto.id;
            this.cancelHandlerStatus();
            this.getTargetStatuses().then(() => {
              this.$refs.InformationHeader.getInformation();
            });
            await this.getRequestData(this.model.id);
            this.ShowToast(
              'Confirmación',
              'La solicitud ha sido cambiada de estatus exitosamente.',
              'success'
            );
          })
          .catch((error) => {
            this.ShowToast(
              'Información Incompleta',
              error.response.data.message,
              'error'
            );
          });
      }
    },
    async validateAnalysisTab(refName) {
      const analysisTabRef = this.$refs[refName];
      if (analysisTabRef && this.canShowSignaturePanel) {
        const isSigned = (await analysisTabRef?.onValidateSignature()) ?? true;

        analysisTabRef.invalidSignature = analysisTabRef.allowAddSignature;

        return !analysisTabRef.invalidSignature && isSigned;
      }
      return true;
    },

    onCancelReturnTo() {
      this.resetRecommendedBox(true);
      switch (this.currentTargetStatus.id) {
        case requestStatusCodes.returnedToSchool:
          if (this.model.statusId == requestStatusCodes.SAEEAnalysisProcess) {
            this.showReturnToSchool = false;
          }
        case requestStatusCodes.CreateProvisionalRemedyRequest:
        case requestStatusCodes.pendingCSEEAnalysis:
          this.showReturnToSchool = false;
          break;
        case requestStatusCodes.returnedToFacilitatorTeacher:
        case requestStatusCodes.SAEEPendingAnalysis:
          this.showReturnToTeacherFacilitator = false;
          break;
        case requestStatusCodes.returnedToCSEEDirector:
          this.showRecommended = false;
          this.showNotRecommended = false;
          this.showReturnToCSEEDirector = false;
          break;
        case requestStatusCodes.recomended: {
          this.showRecommended = false;
          this.showNotRecommended = false;
          this.showReturnToCSEEDirector = false;
          break;
        }
        case requestStatusCodes.notRecomended: {
          this.showNotRecommended = false;
          this.showRecommended = false;
          this.showReturnToCSEEDirector = false;
          break;
        }
      }
    },

    async onContinueReturnTo(model) {
      let valid = false;
      switch (model.currentStatusTargetId) {
        case requestStatusCodes.returnedToSchool: {
          if (this.model.statusId != requestStatusCodes.SAEEAnalysisProcess) {
            valid = await this.validateAnalysisTab(
              'teacherFacilitatorAnalysis'
            );
            this.showReturnToTeacherFacilitator = false;
          }
          valid = true;
          break;
        }
        case requestStatusCodes.returnedToFacilitatorTeacher: {
          valid = await this.validateAnalysisTab('serviceCenterAnalysis');
          this.showReturnToCSEEDirector = false;
          break;
        }
        case requestStatusCodes.returnedToCSEEDirector:
        case requestStatusCodes.recomended:
        case requestStatusCodes.notRecomended:
          if (
            model.currentStatusTargetId === requestStatusCodes.recomended &&
            model.recommendsExisting === false
          ) {
            this.runCreateRemProRequest();
            this.showCreateRempProBtn = true;
            this.persistLazyData({
              ...model,
              currentTargetStatus: this.currentTargetStatus,
              showCreateRempProBtn: this.showCreateRempProBtn,
              showRecommended: this.showRecommended,
              id: this.model.id,
            });
            return;
          }
          await this.openSAEEAnalysisTab();
          valid = this.canShowSignaturePanel
            ? await this.validateAnalysisTab(
                'associateSecretarySpecialEducationAnalysis'
              )
            : true;
          break;
        default:
          valid = true;
          break;
      }

      if (valid) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea poder cambiar el estatus de ${
            requestStatusString[this.model.statusId]
          } a ${requestStatusString[this.currentTargetStatus.id]}?`
        );

        if (answer) {
          await this.onSaveRequest(true);
          await this.getRequestData(this.model.id);

          const dto = {
            id: model.currentStatusTargetId,
            reason: model.reason ?? null,
            authorizationNumber: model.authNumber ?? null,
            dailyShiftId: model.dailyShift?.id ?? null,
            recommendationTypeId: model.recommendationType?.id ?? null,
            recommendsExisting: model.recommendsExisting,
            assistantId: model.assistantId,
          };
          await updateRequestStatus(
            this.isNewIrregularRequestModule,
            this.model.id,
            dto
          )
            .then(async () => {
              if (
                this.model.statusId == requestStatusCodes.SAEEAnalysisProcess
              ) {
                this.onCancelReturnTo();
              }
              this.model.statusId = dto.id;
              this.getTargetStatuses().then(() => {
                this.$refs.InformationHeader.getInformation();
              });
              await this.getRequestData(this.model.id);
              this.ShowToast(
                'Confirmación',
                'La solicitud ha sido cambiada de estatus exitosamente.',
                'success'
              );
            })
            .catch((error) => {
              this.ShowToast(
                'Información Incompleta',
                error.response.data.message,
                'error'
              );
            });
          this.setActiveTab(this.currentTargetStatus.id);
        }
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor escriba los funcionarios que manejan la consulta',
          'error'
        );
      }
    },
    validateStudentRange() {
      const studentLength = this.model.studentList.length;
      if (
        this.model.assistantTypeId == requestTypeCodes.Estudiantes &&
        this.model.studentList.length === 1
      ) {
        return false;
      }
      if (
        this.model.assistantTypeId == requestTypeCodes.DosMasEstudiantes &&
        !_.inRange(studentLength, 0, this.model.requestPersonalTwoOrMoreMax)
      ) {
        return false;
      }
      if (
        this.model.assistantTypeId == requestTypeCodes.Grupo &&
        !_.inRange(studentLength, 0, this.model.requestPersonalGroupMax)
      ) {
        return false;
      }
      return true;
    },
    validateProvRemReqStarted() {
      const isProvRemStatusActive = this.model.studentList.some(
        (student) =>
          student.provRemReqId &&
          student?.provRemRequestService?.serviceStatusId !==
            rpStatuses.Cancelado
      );
      if (isProvRemStatusActive) {
        this.ShowToast(
          'Alerta',
          'La solicitud cuenta con un estudiante por Remedio Provisional.',
          'error'
        );
      }
      return isProvRemStatusActive;
    },
    async fetchStudentParams() {
      this.studentParams = (await getStudentParams()).data;
      this.model = {
        ...this.model,
        ...this.studentParams,
      };
    },
    setActiveTab(statusId) {
      let targetTabIndex = 0;
      if (
        [
          requestStatusCodes.new,
          requestStatusCodes.submitted,
          requestStatusCodes.returnedToSchool,
        ].includes(statusId)
      ) {
        targetTabIndex = this.requestTabs.Solicitud;
      } else if (
        [
          requestStatusCodes.teacherFacilitatorAnalysisProcess,
          requestStatusCodes.returnedToFacilitatorTeacher,
          requestStatusCodes.pendingCSEEAnalysis,
        ].includes(statusId)
      ) {
        targetTabIndex = this.requestTabs.AnalisisFacilitadorDocente;
      } else if (
        [
          requestStatusCodes.CSEEAnalysisProcess,
          requestStatusCodes.returnedToCSEEDirector,
          requestStatusCodes.SAEEPendingAnalysis,
        ].includes(statusId)
      ) {
        targetTabIndex = this.requestTabs.AnalisisCSEE;
      } else if (
        [
          requestStatusCodes.SAEEAnalysisProcess,
          requestStatusCodes.recomended,
          requestStatusCodes.notRecomended,
        ].includes(statusId)
      ) {
        targetTabIndex = this.requestTabs.AnalisisSAEE;
      }

      this.$nextTick(() => {
        this.tabIndex = targetTabIndex;
      });
    },
    setManualSaveFunc(refSaveFunc) {
      this.saveFunction = refSaveFunc;
    },
    setCurrentSaveFunction(tab) {
      switch (tab) {
        case this.requestTabs.Solicitud:
        case this.requestTabs.ListadoDeEstudiantes:
          this.setManualSaveFunc(null);
          break;

        case this.requestTabs.AnalisisFacilitadorDocente:
          this.setManualSaveFunc(this.$refs.teacherFacilitatorAnalysis.save);
          break;

        case this.requestTabs.AnalisisCSEE:
          this.setManualSaveFunc(this.$refs.serviceCenterAnalysis.save);
          break;

        case this.requestTabs.AnalisisSAEE:
          this.setManualSaveFunc(
            this.$refs.associateSecretarySpecialEducationAnalysis.save
          );
          break;
      }

      this.tabIndex = tab;
    },
    goToResumePage() {
      this.$router.push({
        path: `/humanres/request/resume/${this.$route.params.id}`,
      });
    },
    createProvisionalRemedyRequest(studentSieId) {
      if (!studentSieId) {
        this.goToTab(this.requestTabs.ListadoDeEstudiantes);
        return;
      }
      this.$router.push({
        name: 'AddProvRemedyReq',
        params: {
          requestId: this.model.id,
          studentSieId,
        },
      });
    },
  },
  async mounted() {
    const response = await getSysparameterByNames({
      parameterNames: ['RHSignaturePanelHidden'],
    });
    this.sysParameters = response.data;

    await this.fetchDropDownsData();
    await this.fetchResources();
    await this.fetchStudentParams();
    if (this.$route.params.id) {
      await this.getRequestData(this.$route.params.id);
      await this.getTargetStatuses();
    } else {
      this.setPrincipalDocumentTypeName();
    }
    this.goToTab(this.tab);

    this.loadPersistedData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.bg-light-gray-f2 {
  background-color: #f7f7f7;
}
.orange-icon {
  color: #ff7058;
}
.document-name {
  font: normal normal normal 16px/20px Lato;
  letter-spacing: 0px;
  color: #11291b;
  opacity: 1;
}
.radius-20 {
  border-radius: 20px;
}
.radius-100 {
  border-radius: 100%;
}
.div-error {
  background: #feeaea;
  padding: 20px;
}
.div-error p {
  color: #c9545e;
  font: normal normal normal 16px/19px Lato;
  border-radius: 0px 0px 5px 5px;
}
::v-deep .custom-tab-container {
  margin-bottom: 20px;
}
::v-deep .read-only .input-display > label {
  color: $gray_6 !important;
  margin-bottom: 5px !important;
}
::v-deep #dropdownMenuButton {
  background-color: transparent !important;
  color: black !important;
}
</style>
